const AWS = require('aws-sdk');

export const S3_BASE_URL = 'https://goyohan-mobility.s3.ap-northeast-2.amazonaws.com/';
export const S3_BUCKET = 'goyohan-mobility';
export const S3_PATH = 'public/business/company/';
export const S3 = new AWS.S3({
  accessKeyId: 'AKIAXRINOBB6Q2IP57HW',
  secretAccessKey: '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',
  region: 'ap-northeast-2'
});

export const addValidation = (isValid) => {
  switch (isValid) {
    case true:
      return "is-valid";

    case false:
      return "is-invalid";

    default:
      return "";
  }
};

export const inputValidation = (isValid) => {
  switch (isValid) {
    case true:
      return "isValid";

    case false:
      return "isInvalid";

    default:
      return "";
  }
};

export const setPhoneTemplate = (x) => {
  if (!x) return null;
  return `${x.slice(0, 3)}-${x.slice(3, 7)}-${x.slice(7)}`;
};

export const setCorporateNumberTemplate = (x) => {
  if (!x) return null;
  return `${x.slice(0, 3)}-${x.slice(3, 5)}-${x.slice(5)}`;
};

export const thousandFormat = (number) => {
  return new Intl.NumberFormat().format(number);
};

export const getToday = () => {
  return new Date().toISOString().split("T")[0];
};

export const getDate = (date) => {
  return date.toISOString().split("T")[0];
};

export const setNameMasking = (name) => {
  let char = name.charAt(1);
  let maskingStr = name.replace(char, "*");
  return maskingStr;
};


export const getTimeStamp = () => {
  const date = new Date();
  return date.getFullYear()+addZero(date.getMonth()+1, 2)+addZero(date.getDate(), 2)+addZero(date.getHours(), 2)+addZero(date.getMinutes(), 2)+addZero(date.getSeconds(), 2)+date.getMilliseconds();
}

export const addZero = (date, number) => {
  let zero = '';
  date = date.toString();

  if (date.length < number) {
    for (let i = 0; i < number - date.length; i++)
      zero += '0';
  }
  return zero + date;
}